<script setup lang="ts">
import { Dayjs } from 'dayjs'
import { computed, watch } from 'vue'
import { useStore } from 'vuex'

import { ChartUnit } from './types'
import VolumeGraphics from './VolumeGraphics.vue'

export interface GlobalStatsProps {
  earlyLimit: Dayjs
  lateLimit: Dayjs
  chartUnit: ChartUnit
  selectedMedicalUnits: number[] | null
  labelSets: string[]
}

const props = withDefaults(
  defineProps<GlobalStatsProps>(),
  {
    chartUnit: ChartUnit.MONTH,
    selectedMedicalUnits: () => [],
    labelSets: () => []
  }
)
const store = useStore()
const stats = computed(() => store.state.stats.globalStats)
const statsPercent = computed(() =>  store.state.stats.globalStats.map((s) => {
  return {
    prctAutomatableStay: s.countStay > 0 ? ((s.countAutomatableStay / s.countStay) * 100.0).toFixed(2) : 0,
    prctShortStay: s.countStay > 0 ? ((s.countNewCodingStay / s.countStay) * 100.0).toFixed(2) : 0,
    prctLongStay: s.countStay > 0 ? ((s.countOptimizableStay / s.countStay) * 100.0).toFixed(2) : 0,
  }
})
)

watch([() => props.earlyLimit, () => props.lateLimit, () => props.chartUnit, () => props.selectedMedicalUnits], () => {
  refresh()
}, { immediate: true })

function refresh() {
  store.dispatch('getGlobalStats', {
    earlyLimit: props.earlyLimit.format('YYYY-MM-DD'),
    lateLimit: props.lateLimit.format('YYYY-MM-DD'),
    unit: props.chartUnit,
    medicalUnits: props.selectedMedicalUnits,
  })
}

</script>

<template>
  <div class="stat">
    <h1 class="stat-title">
      Statistiques Globales
    </h1>
    <volume-graphics
      :label-sets="labelSets"
      :stats="stats"
      :stats-percent="statsPercent"
      :prct-infos="{
        prctAutomatableStay: { label: 'Automatisation', unit: '%' },
        prctShortStay: { label: 'Primo-codage', unit: '%' },
        prctLongStay: { label: 'Séjours revalorisables', unit: '%' }
      }"
      :stats-infos="{
        countStay: { label: 'Total', unit: 'séjour(s)' },
        countAutomatableStay: { label: 'Automatisation', unit: 'séjour(s)' },
        countNewCodingStay: { label: 'Primo-codage', unit: 'séjour(s)' },
        countOptimizableStay: { label: 'Séjours optimisables', unit: 'séjour(s)' }
      }"
    />
  </div>
</template>
